import { Cmp, Mod, state } from ":mods";
import { adminApis } from "../../apis";
import { Match, Switch, batch, createEffect, splitProps } from "solid-js";
import { useParams } from "@solidjs/router";
import { AShowcase, EditShowcaseViewProps } from "../../model";
import { ShowcaseForm } from "./showcase-form";

import "../../css/showcase.css";

export function EditShowcase(props: EditShowcaseViewProps) {
  const [local, others] = splitProps(props, ["$", "stageID"]);
  const params = useParams();
  const stageID = local.stageID ?? params.id; //local.$.actions.getStageSelected();
  const $list = state.createAsync([adminApis.listGet, stageID]);
  local.$.actions.setLayout({
    title: "Edit Showcases for " + Mod.Courses.CONST.STAGES[stageID],
  });

  function getPayload(values: AShowcase) {
    const payload = new FormData();
    const { image, ...v } = values;
    payload.append("data", JSON.stringify(v));
    payload.append("image", image as any);
    return payload as any;
  }

  function onCreate(values: AShowcase) {
    const payload = getPayload(values);
    adminApis
      .listPost(stageID, payload as any)
      .then((obj) => {
        console.log("obj is :: ", obj);
        $list.set((s) => ({
          ...s,
          data: {
            ...s.data,
            show_cases: [...s.data.show_cases, obj as any],
          },
        }));
      })
      .catch((res) => {
        console.log("res is :: ", res);
        const err = res.response.data.error;
        local.$.actions.pushToast({
          type: "error",
          message: typeof err === "string" ? err : err.join("\n"),
        });
      });
  }

  function onUpdate(values: AShowcase, index: number) {
    const payload = getPayload(values);
    adminApis
      .detailsPut(values.id, payload)
      .then(() => {
        $list.set((s) => {
          const new_arr = [...s.data.show_cases];
          new_arr[index] = { ...new_arr[index], ...values };
          return { ...s, data: { ...s.data, show_cases: new_arr } };
        });
      })
      .catch((res) => {
        console.log("res is :: ", res);
        const err = res.response.data.error;
        local.$.actions.pushToast({
          type: "error",
          message: typeof err === "string" ? err : err.join("\n"),
        });
      });
  }

  function onDelete(indices: number[]) {
    const ids = indices.map((i) => $list.value.data.show_cases[i].id);
    const remove = [] as number[];
    adminApis.detailsDelete(ids).then((obj) => {
      obj.forEach((item) => {
        if (item.error) {
          local.$.actions.pushToast({
            type: "error",
            message: item.error,
          });
        }
        remove.push(item.id);
      });
      if (remove.length > 0) {
        $list.set((s) => ({
          ...s,
          data: { ...s.data, show_cases: s.data.show_cases.filter((x, i) => !remove.includes(x.id)) },
        }));
        local.$.actions.pushToast({
          type: "success",
          message: "Deleted " + remove.length + " showcases",
        });
      }
    });
  }

  return (
    <Switch fallback={<div>unknown resource state </div>}>
      <Match when={$list.state.loading}>Loading...</Match>
      <Match when={$list.state.failed}>An error occured while fetching stage data {$list.error} ...</Match>
      <Match when={$list.state.success}>
        <main class="flex flex-col w-full h-full">
          <Cmp.List.Table
            rows={$list.value.data.show_cases}
            rowClass="w-full flex flex-row  text-20px"
            rowContainerClass="w-full flex flex-row rounded-lg px2 text-20px"
            colsClasses={{
              id: "!w-10% text-start capitalize",
              name: "!w-90% text-start capitalize",
              // actions: "!w-30% capitalize",
            }}
            events={{
              onAllRows({ event, selected }) {
                console.log("action for all is ", event, selected);
                if (event === "delete") {
                  onDelete(selected);
                } else if (event === "create") {
                  local.$.actions.pushModal({
                    title: "Create New Showcase",
                    element: (event) => (
                      <ShowcaseForm
                        stage={stageID}
                        onDone={(values, payload) => {
                          event("close");
                          onCreate(values as any);
                        }}
                      />
                    ),
                  });
                }
              },
              onSingleRow({ event, item, index, rows }) {
                if (event === "delete") {
                  onDelete([index]);
                } else if (event === "clicked") {
                  // onClickedItem(item.id);
                } else if (event === "create") {
                  local.$.actions.pushModal({
                    title: `Create New Showcase (Template of ${item.name})`,
                    element: (event) => (
                      <ShowcaseForm
                        stage={stageID}
                        showcase={item.id}
                        onDone={(values) => {
                          event("close");
                          onCreate(values as any);
                        }}
                      />
                    ),
                  });
                } else if (event === "edit") {
                  local.$.actions.pushModal({
                    title: `Update Showcase ${item.name}`,
                    element: (event) => (
                      <ShowcaseForm
                        stage={stageID}
                        showcase={item.id}
                        buttonMsg="Update"
                        onDone={(values) => {
                          event("close");
                          onUpdate(values as any, index);
                        }}
                      />
                    ),
                  });
                }
              },
            }}
          />
        </main>
      </Match>
    </Switch>
  );
}
